/**
 * Component adapted from SEAC Corporate Website
 * https://github.com/oozou/seac-corporate-website/blob/v1.0.3/packages/web/src/certificate/courses/QA.tsx
 */

import { Disclosure, Transition } from '@headlessui/react';
import { FC } from 'react';
import { ChevronDown } from '../ui-kit/icons';
import cx from 'classnames';
import Markdown from '../ui-kit/Markdown';

export const MobileDisclosure: FC<{
  listItem: any;
}> = ({ listItem }) => {
  return (
    <div
      className="w-full border-b-2 border-l-0 border-r-0 border-t-0 border-gray-200 py-4"
      key={`MobileDisclosure-${listItem.id}`}
    >
      <Disclosure>
        {({ open }) => (
          <>
            <Disclosure.Button className="focus-visible:ring-none flex w-full items-center justify-between outline-none focus:outline-none focus-visible:ring-4">
              <p
                key={listItem.id}
                className={`w-full py-4 text-left text-subheading font-bold text-black`}
              >
                {listItem.title}
              </p>
              <ChevronDown
                className={cx('h-6 w-6 transition-all', {
                  'rotate-180 transform': open,
                })}
              />
            </Disclosure.Button>
            <Transition
              enter="transform transition ease-out duration-100"
              enterFrom="opacity-0 scale-95"
              enterTo="opacity-100 scale-100"
              leave="transform transition-ease-in duration-75 transform-gpu"
              leaveFrom="opacity-100 scale-100"
              leaveTo="opacity-0 scale-95"
            >
              <Disclosure.Panel className="mt-4 flex flex-col text-body font-regular text-gray-650">
                {listItem.caption && (
                  <p className="text-subheading font-semibold text-black">
                    {listItem.caption}
                  </p>
                )}
                <Markdown className="text-gray-650">
                  {listItem.description}
                </Markdown>
              </Disclosure.Panel>
            </Transition>
          </>
        )}
      </Disclosure>
    </div>
  );
};
